export const EDIT_BRANCH = 1;
export const COPY_BRANCH = 2;
export const CREATE_BRANCH = 3;

export const SIMPLE_INPUTS = ['text', 'password', 'email', 'number', 'search', 'tel', 'url', /*'checkbox'*/];
export const DATE = 'date';
export const SELECT = 'select';
export const TEXTAREA = 'textarea';
export const FILE = 'file';
export const RADIO_LIST = 'radio-list';
export const GROUP = 'group';

export const SEND_COMMENT = 1;
export const EDIT_COMMENT = 2;

export const NOTIFICATION_SUCCESS = 'success';
export const NOTIFICATION_DANGER = 'danger';
export const NOTIFICATION_WARNING = 'warning';
export const NOTIFICATION_INFO = 'info';

